import styled from 'styled-components';

import { colors, fonts } from 'shared/defaultTheme';

export const Div = styled.div`
  width: 100%;
  height: 45px;
  cursor: pointer;
  padding: 1rem 2rem;
`;

export const Li = styled.li`
  background: ${({ selectedColor }) => selectedColor};
  &:hover {
    background: ${colors.whiteSmoke};
  }
`;

export const Individual = styled.div`
  height: 45px;
  width: 100%;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ showTypeNotifications }) =>
    !showTypeNotifications ? colors.whiteSmoke : 'transparent'};
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
  span {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
`;

export const Massive = styled.div`
  height: 45px;
  width: 100%;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ showTypeNotifications }) =>
    showTypeNotifications ? colors.whiteSmoke : 'transparent'};
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
  span {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
`;
